var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fas fa-spinner fa-spin mr-1"}),_vm._t("default",[_c('span',[_vm._v("Cargando ...")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }